<template>
  <section></section>
</template>
<script>
export default {
  created() {
    // 跳转到在线充值
    window.location.href = resp.data.zxtServiceDeposite;
  }
}
</script>



// WEBPACK FOOTER //
// deposite.vue?ed9bb79a